import React from "react";
import { FaStar, FaRegStar } from "react-icons/fa";

export const StarDisplay = ({ value = 0, count, size = 14 }) => {
  const rounded = Math.round(Number(value) || 0);
  return (
    <span className="inline-flex items-center gap-1 text-amber-500">
      {[1, 2, 3, 4, 5].map((i) =>
        i <= rounded ? (
          <FaStar key={i} size={size} />
        ) : (
          <FaRegStar key={i} size={size} />
        )
      )}
      {typeof count === "number" && (
        <span className="ml-1 text-xs font-medium text-ink-500">
          {Number(value || 0).toFixed(1)} ({count})
        </span>
      )}
    </span>
  );
};

export const StarInput = ({ value, onChange, size = 22 }) => (
  <span className="inline-flex items-center gap-1 text-amber-500">
    {[1, 2, 3, 4, 5].map((i) => (
      <button
        key={i}
        type="button"
        onClick={() => onChange(i)}
        className="focus:outline-none"
        aria-label={`${i} star`}
      >
        {i <= value ? <FaStar size={size} /> : <FaRegStar size={size} />}
      </button>
    ))}
  </span>
);

export default StarDisplay;
